'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Debounce = exports.debounce = void 0;
var vue_class_component_1 = require("vue-class-component");
function debounce(func, waitMilliseconds, isImmediate) {
    if (waitMilliseconds === void 0) { waitMilliseconds = 100; }
    if (isImmediate === void 0) { isImmediate = false; }
    var timeoutId;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var doLater = function () {
            timeoutId = undefined;
            if (!isImmediate) {
                func.apply(context, args);
            }
        };
        var shouldCallNow = isImmediate && timeoutId === undefined;
        if (timeoutId !== undefined) {
            window.clearTimeout(timeoutId);
        }
        timeoutId = window.setTimeout(doLater, waitMilliseconds);
        if (shouldCallNow) {
            func.apply(context, args);
        }
    };
}
exports.debounce = debounce;
var Debounce = function (delayMs, isImmediate) {
    if (isImmediate === void 0) { isImmediate = false; }
    return vue_class_component_1.createDecorator(function (options, key) {
        if (!options.methods) {
            options.methods = {};
        }
        var functionToDebounce = options.methods[key];
        if (functionToDebounce && delayMs > 0) {
            options.methods[key] = debounce(functionToDebounce, delayMs, isImmediate);
        }
    });
};
exports.Debounce = Debounce;
